export default "__VITE_ASSET__CGya89G$__"